import { render, staticRenderFns } from "./color-select.vue?vue&type=template&id=ee6d0080&scoped=true&"
import script from "./color-select.vue?vue&type=script&lang=js&"
export * from "./color-select.vue?vue&type=script&lang=js&"
import style0 from "./color-select.vue?vue&type=style&index=0&id=ee6d0080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6d0080",
  null
  
)

export default component.exports